import BasketView from '@/views/BasketView';
import DesignAdd from '@/views/design/DesignAdd';
import DesignListEdit from '@/views/design/DesignListEdit';
import DesignEdit from '@/views/design/DesignEdit';
import ProductChange from '@/views/product/ProductChange';
import ProductColor from '@/views/product/ProductColor';
import ProductFilter from '@/views/product/ProductFilter';
import TextEdit from '@/views/text/TextEdit';
import TextFont from '@/views/text/TextFont';
import TextColor from '@/views/text/TextColor';
import TextEffectChange from '@/views/text/TextEffectChange';
import TextEffectColor from '@/views/text/TextEffectColor';
import UploadEdit from '@/views/upload/UploadEdit';
import UploadDesignEdit from '@/views/upload/UploadDesignEdit';
import UploadDesignAdd from '@/views/upload/UploadDesignAdd';
import UploadDesignEffectchange from '@/views/upload/UploadDesignEffectChange';
import SelectPrintStyle from '@/views/SelectPrintStyle';
import ProductMenu from '@/views/product/ProductMenu';
import ProductInfo from '@/views/product/ProductInfo';

export default [
  {
    name: 'basket',
    component: BasketView,
    tracking: {
      contentGroup1: 'PreBasket',
      contentGroup2: 'PreBasket',
      contentGroup3: 'PreBasket'
    }
  },
  {
    name: 'productinfo',
    component: ProductInfo
  },
  {
    name: 'add-design',
    component: DesignAdd
  },
  {
    name: 'list-designs',
    component: DesignListEdit
  },
  {
    name: 'edit-design',
    component: DesignEdit,
    tracking: {
      contentGroup2: 'Creator_MotifEdit',
      contentGroup3: 'Creator_MotifEdit'
    }
  },
  {
    name: 'product',
    component: ProductMenu,
    tracking: {
      contentGroup2: 'Creator_Product',
      contentGroup3: 'Creator_Product'
    }
  },
  {
    name: 'product-change',
    component: ProductChange,
    tracking: {
      contentGroup2: 'Creator_Product',
      contentGroup3: 'Creator_ChangeProduct'
    }
  },
  {
    name: 'product-color',
    component: ProductColor,
    tracking: {
      contentGroup2: 'Creator_Product',
      contentGroup3: 'Creator_ChangeProductColor'
    }
  },
  {
    name: 'product-filter',
    component: ProductFilter
  },
  {
    name: 'edit-text',
    component: TextEdit,
    tracking: {
      contentGroup2: 'Creator_Text',
      contentGroup3: 'Creator_Text'
    }
  },
  {
    name: 'list-font',
    component: TextFont,
    tracking: {
      contentGroup2: 'Creator_EditText',
      contentGroup3: 'Creator_EditFont'
    }
  },
  {
    name: 'list-color',
    component: TextColor,
    tracking: {
      contentGroup2: 'Creator_EditText',
      contentGroup3: 'Creator_EditColor'
    }
  },
  {
    name: 'change-text-effect',
    component: TextEffectChange,
    tracking: {
      contentGroup2: 'Creator_TextEdit',
      contentGroup3: 'Creator_TextEditEffect'
    }
  },
  {
    name: 'change-text-effect-color',
    component: TextEffectColor,
    tracking: {
      contentGroup2: 'Creator_TextEdit',
      contentGroup3: 'Creator_TextEditEffectColor'
    }
  },
  {
    name: 'edit-upload',
    component: UploadEdit
  },
  {
    name: 'edit-upload-image',
    component: UploadDesignEdit
  },
  {
    name: 'add-upload',
    component: UploadDesignAdd,
    tracking: {
      contentGroup2: 'Creator_Picture',
      contentGroup3: 'Creator_Picture'
    }
  },
  {
    name: 'change-upload-effect',
    component: UploadDesignEffectchange
  },
  {
    name: 'printstyle',
    component: SelectPrintStyle,
    tracking: {
      contentGroup2: 'Creator_PrintType',
      contentGroup3: 'Creator_PrintType'
    }
  }
];
